const GET_DISPOSITION_PENALTY_FLAG_SAVE = 'GET_DISPOSITION_PENALTY_FLAG_SAVE';
const SET_DISPOSITION_PENALTY_FLAG_SAVE = 'SET_DISPOSITION_PENALTY_FLAG_SAVE';

export
{
    GET_DISPOSITION_PENALTY_FLAG_SAVE,
    SET_DISPOSITION_PENALTY_FLAG_SAVE
};